import { Link, useLocation } from "react-router-dom";
import { FileText, LayoutDashboard } from "lucide-react";

export default function Header() {
  const loc = useLocation();
  const isBuilder = loc.pathname.startsWith("/builder") || loc.pathname.startsWith("/sign");
  return (
    <header className="sticky top-0 z-40 w-full bg-white/85 backdrop-blur border-b border-[var(--csd-border)]">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <div className="w-8 h-8 rounded-lg bg-[var(--csd-primary)] grid place-items-center text-white">
            <FileText size={18} />
          </div>
          <span className="font-heading font-extrabold text-lg tracking-tight">CarSaleDoc</span>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-[var(--csd-text-secondary)]">
          <Link to="/car-bill-of-sale" data-testid="nav-about" className="hover:text-[var(--csd-primary)]">How it works</Link>
          <Link to="/by-state" data-testid="nav-states" className="hover:text-[var(--csd-primary)]">By state</Link>
          <Link to="/private-sale-car-value-calculator" data-testid="nav-calculator" className="hover:text-[var(--csd-primary)]">Car value</Link>
          <Link to="/sample-pdf" data-testid="nav-sample" className="hover:text-[var(--csd-primary)]">Sample PDF</Link>
          <Link to="/dashboard" data-testid="nav-dashboard" className="hover:text-[var(--csd-primary)] flex items-center gap-1">
            <LayoutDashboard size={14} /> Dashboard
          </Link>
        </nav>
        {!isBuilder && (
          <Link
            to="/builder/new"
            data-testid="header-cta-create"
            className="csd-btn-primary px-4 py-2 rounded-xl text-sm font-semibold"
          >
            Create Bill of Sale
          </Link>
        )}
      </div>
    </header>
  );
}
